export default __webpack_public_path__ + "static/diamondbacks-fbd4ac6031921d383c86af62dfab00a5.png";